import styled, { css } from 'styled-components';

const Pill = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  padding: 8px 12px;
  margin: 4px;
  height: 20px;
  font-size: 13px;
  width: fit-content;
  text-transform: capitalize;
  font-weight: 500;
  line-height: 17.7px;

  ${(props) => {
    if (props.color === 'purple') {
      return css`
        color: ${({ theme }) => theme.COLOR_STATUS_TAG_PURPLE_TEXT};
        background: ${({ theme }) => theme.COLOR_STATUS_TAG_PURPLE_BG};
      `;
    }
    if (props.color === 'blue') {
      return css`
        color: ${({ theme }) => theme.COLOR_STATUS_TAG_BLUE_TEXT};
        background: ${({ theme }) => theme.COLOR_STATUS_TAG_BLUE_BG};
      `;
    }
    if (props.color === 'green') {
      return css`
        color: ${({ theme }) => theme.COLOR_STATUS_TAG_GREEN_TEXT};
        background: ${({ theme }) => theme.COLOR_STATUS_TAG_GREEN_BG};
      `;
    }
    if (props.color === 'red') {
      return css`
        color: ${({ theme }) => theme.COLOR_WHITE};
        background: ${({ theme }) => theme.COLOR_PRIMARY};
      `;
    }
    if (props.color === 'black') {
      return css`
        color: ${({ theme }) => theme.COLOR_WHITE};
        background: ${({ theme }) => theme.COLOR_BLACK};
      `;
    }
    return css`
      color: ${({ theme }) => theme.COLOR_STATUS_DEFAULT_TEXT};
      background: ${({ theme }) => theme.COLOR_STATUS_DEFAULT_BG};
    `;
  }}
`;

const DeleteButton = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  color: #555;
  font-size: 16px;
  margin-left: 8px;
`;

const StyledPill = {
  Pill,
  DeleteButton,
};

export default StyledPill;
